/*
 * Custom view for reports that only need one report, but need a lot of space.
 * To start with, that means the Topic Listing report.
 */

define([
  "marionette",
  "underscore",
  "modules/reportSplit/reports/reportArea/template/oneBigReportView.html",
  "highcharts/highcharts",
], function (Marionette, _, OneBigReportTemplate, Highcharts) {
  "use strict";

  const OneBigReportView = {};

  OneBigReportView.reportsLayout = Marionette.Layout.extend({
    template: OneBigReportTemplate,
    className: "max-height",
    regions: {
      chart: "#chart",
      configEntries: "#configDiv",
    },
    getHighcharts: function (area) {
      // NOTE: Cannot use the ui functionality built-in to MarionetteJS because it is
      // evaluated too soon.
      if ("center" === area) {
        const chartId = this.$el.find("#chart > div").data("highcharts-chart");
        if (!_.isUndefined(chartId) && !_.isNull(chartId)) {
          return Highcharts.charts[+chartId];
        }
      }
    },
  });

  return OneBigReportView;
});
